import React from "react"
import { css } from "styled-components"
import externalLinks from "../../external-links"
import EmailSignup from "../atoms/email-signup"
import { Spacer } from "../atoms/layout-primitives"
import Text from "../atoms/text"
import VariantContainer, { IStyleVariant } from "../atoms/variant-container"
import { BT } from "../styles/blog-typography"
import mergeVariants from "../util/merge-variants"

interface INewsletterSignupProps {
  title?: string
  copy?: string
  variants?: IStyleVariant | any[]
}

const NewsletterSignup = ({
  title,
  copy,
  variants,
}: INewsletterSignupProps) => {
  return (
    <VariantContainer
      variants={mergeVariants(
        [
          css`
            grid-column: 1 / -1;
            display: flex;
            flex-direction: column;
            text-align: center;
          `,
          css`
            justify-items: center;
          `,
        ],
        variants
      )}
    >
      {title && (
        <Text
          as="h1"
          variants={[
            css`
              ${BT.sm.h1`500`};
            `,
            css`
              ${BT.md.h1`500`};
            `,
          ]}
        >
          {title}
        </Text>
      )}
      <Spacer height={{ sm: "12px" }} />
      {copy && (
        <Text
          as="p"
          variants={[
            css`
              ${BT.sm.body`400`};
            `,
            css`
              ${BT.md.body`400`}
            `,
          ]}
        >
          {copy}
        </Text>
      )}
      <Spacer height={{ sm: "24px" }} />
      <EmailSignup endpoint={externalLinks.hubspot.emailFooterSubmissionApi} />
    </VariantContainer>
  )
}

export default NewsletterSignup
